import styled from "styled-components";
import { theme } from "../../../theme";
import Body from "../typography/Body";
import { DownloadIcon } from "../icons/DownloadIcon";
import { VerticalSpacer } from "../Spacers";
import SmallLoadingSpinner from "../SmallLoadingSpinner";
import type { ReactNode } from "react";
import BodySmall from "../typography/BodySmall";

interface Props {
  onClick?: (props?: any) => void;
  disabled?: boolean;
  title?: string;
  color?: string;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  icon?: ReactNode;
  small?: boolean;
}

const ButtonContainer = styled.button<{ disabled?: boolean; color: string }>`
  background-color: transparent;
  border: none;
  border-bottom: 1.5px solid ${(props) => props.color};
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  cursor: pointer;

  &:hover {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  &:disabled {
    border-bottom: 1.5px solid
      ${(props) => props.disabled && theme.colors.disabled};
  }
`;

const DownloadButton: React.FC<Props> = ({
  onClick,
  disabled,
  title,
  color,
  type,
  loading,
  icon,
  small,
}) => {
  const buttonColor = color ?? theme.colors.primary;

  return (
    <ButtonContainer
      disabled={disabled || loading}
      color={buttonColor}
      onClick={onClick}
      type={type}
    >
      {icon ? icon : <DownloadIcon color={buttonColor} />}
      {title && <VerticalSpacer spacing={0.5} />}
      {small ? (
        <BodySmall color={buttonColor}>{title}</BodySmall>
      ) : (
        <Body fontweight="700" color={buttonColor}>
          {loading ? <SmallLoadingSpinner /> : title}
        </Body>
      )}
    </ButtonContainer>
  );
};

export default DownloadButton;
